import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const deleteBus = id => {
  return api.delete(`/admin/buses-v2/${id}`);
};

export const useDeleteBusMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: deleteBus,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries({
        queryKey: ["buses"],
      });
      queryClient.removeQueries({
        queryKey: ["delete-bus-simulate"],
      });
    },
    ...restConfig,
  });
};
